// Fetch the variant inventory data using the custom template for a product
function fetchProductInventory(productHandle) {
    return fetch(`/products/${productHandle}?view=variant-details`)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        });
}

// Fetch the cart data using Shopify AJAX API
function fetchCart() {
    return fetch('/cart.js')
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        });
}

// Function to check and disable quantity buttons
function checkVariantQuantity() {
    var mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('loading');
  
    fetchCart().then(function(cart) {
        let variantQuantities = {}; // To store total quantity of each variant
        let productHandles = new Set(); // To store unique product handles

        // Loop through cart items and store quantities by variant ID
        cart.items.forEach(function(item) {
            let variantId = item.variant_id;
            let variantQty = item.quantity;

            // Accumulate total quantity of the same variant
            if (variantQuantities[variantId]) {
                variantQuantities[variantId] += variantQty;
            } else {
                variantQuantities[variantId] = variantQty;
            }

            // Collect unique product handles for inventory fetching
            productHandles.add(item.handle);
        });

        // Now fetch inventory for all unique products in the cart
        let inventoryPromises = Array.from(productHandles).map(productHandle => fetchProductInventory(productHandle));

        // Wait for all inventory data to be fetched
        Promise.all(inventoryPromises).then(function(products) {
            // Process each product's inventory
            products.forEach(function(data) {
                data.variants.forEach(function(variant) {
                    let availableQty = variant.maxLimit;
                    let variantId = variant.id;
                    let totalQtyInCart = variantQuantities[variantId] || 0;

                    console.log('availableQty',availableQty,totalQtyInCart);
                    if(availableQty){
                      // Disable all quantity buttons for this variant if total in cart reaches available inventory
                      if (totalQtyInCart >= availableQty) {
                          disableQuantityButtons(variantId);
                      } else {
                          enableQuantityButtons(variantId);
                      }
                    }
                });
            });
        }).catch(function(error) {
            console.error('Error fetching product inventories:', error);
        }).finally(function() {
            // This will always be called after all then/catch blocks complete
            var mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
            mainCartItems.classList.remove('loading');
        });
    }).catch(function(error) {
        console.error('Error fetching cart:', error);
    });
}

// Function to disable all the plus quantity buttons for a specific variant
function disableQuantityButtons(variantId) {
    let quantityPlusButtons = document.querySelectorAll(`[data-line-item="${variantId}"] .quantity__button[name="plus"]`);
    quantityPlusButtons.forEach(function(button) {
        button.disabled = true;
    });
}

// Function to enable all the plus quantity buttons for a specific variant
function enableQuantityButtons(variantId) {
    let quantityPlusButtons = document.querySelectorAll(`[data-line-item="${variantId}"] .quantity__button[name="plus"]`);
    quantityPlusButtons.forEach(function(button) {
        button.disabled = false;
    });
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    checkVariantQuantity();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
checkVariantQuantity();